<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $tc("edit") }} {{ $tc("distributor", 1) }} {{ $t("contract") }}
      </div>
      <router-link class="btn-blue" to="distributor-contract"
        >{{ $tc("distributor", 1) }} {{ $t("contract") }}
        {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <!-- <label
                :class="selecedCinema.length > 0 ? 'shift-up' : '' "
              >{{ $t('select') }} {{ $tc('cinema', 1) }}</label>
              <b-dropdown
                :disabled="isRoleID"
                :text="selecedCinema"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Cinema, CinemaIndex) in Cinemas"
                  :key="CinemaIndex"
                  v-on:click="onSelectCinema($event, Cinema)"
                >{{ Cinema.cine_name }}</b-dropdown-item>
              </b-dropdown> -->
              <multiselect
                :options="Cinemas"
                v-model="distributorContracts.cine_name_list"
                :searchable="true"
                label="cine_name"
                track-by="cine_name"
                placeholder="Select Cinema"
                :preselect-first="true"
                @select="onSelectCinema($event)"
                v-b-tooltip.hover
                :title="$t('cinemadesignationscontract')"
              />
            </div>
            <!--Tooltip :title="$t('cinemadesignationscontract')" /--->
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <multiselect
                v-model="distributorContracts.md_id_list"
                placeholder="Select Movie"
                :options="Movies"
                label="movie"
                track-by="md_id"
                @select="onSelectMovie($event)"
                v-b-tooltip.hover
                :title="$t('moviedesignationcontract')"
              ></multiselect>
              <!-- :multiple="true" -->
            </div>
            <!--Tooltip :title="$t('moviedesignationcontract')" /--->
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <!-- <label :class="selectedDistributor.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("distributor", 1) }}</label
              >
              <b-dropdown
                :text="selectedDistributor"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Distributor, DistributorIndex) in Distributors"
                  :key="DistributorIndex"
                  v-on:click="onSelectDistributor($event, Distributor)"
                  >{{ Distributor.d_company_name }}</b-dropdown-item
                >
              </b-dropdown> -->
              <multiselect
                :options="Distributors"
                v-model="distributorContracts.d_company_name_list"
                :searchable="true"
                label="d_company_name"
                track-by="d_company_name"
                placeholder="Select Distributor"
                :preselect-first="true"
                @select="onSelectDistributor($event)"
                v-b-tooltip.hover
                :title="$t('distributordesignationname')"
              />
            </div>
            <!--Tooltip :title="$t('distributordesignationname')" /-->
          </div>
        </div>

        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="dropdown-curve-container">
              <!-- <label :class="selectedContract.length > 0 ? 'shift-up' : ''"
                >{{ $t("select") }} {{ $tc("contract", 1) }}</label
              >
              <b-dropdown
                :text="selectedContract"
                variant="dropdown-curve"
                class="w-100"
              >
                <b-dropdown-item
                  v-for="(Contract, ContractIndex) in Contracts"
                  :key="ContractIndex"
                  v-on:click="onSelecteContract($event, Contract)"
                  >{{ Contract.contract_weekwise_name }}</b-dropdown-item
                >
              </b-dropdown> -->
              <multiselect
                :options="Contracts"
                v-model="distributorContracts.contract_weekwise_name_list"
                :searchable="true"
                label="contract_weekwise_name"
                track-by="contract_weekwise_name"
                placeholder="Select Contract"
                :preselect-first="true"
                @select="onSelecteContract($event)"
                v-b-tooltip.hover
                :title="$t('distributordesignationname')"
              />
            </div>
            <!--Tooltip :title="$t('distributordesignationname')" /--->
          </div>
        </div>

        <!-- <div class="col-lg-12 col-xl-12">
          <div class="row mx-0">
            <div
              v-for="(distributorWeeklyContract, distributorWeeklyContractIndex) in distributorWeeklyContracts"
              :key="distributorWeeklyContractIndex"
              class="col-12 p-3 border rounded-10 mb-4"
            >
              <div class="row">
                <div class="col-11">
                  <div class="row">
                    <div class="col-lg-4 mb-4 align-self-center">
                      <h6
                        class="mb-0"
                      >{{ $tc('distributor', 1) }} {{ $t('contract') }} {{ $tc('details', 2)}}</h6>
                    </div>
                    <div class="col-lg-4 mb-4">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <Datepicker :monday-first="true"
                            ref="programaticOpen"
                            v-model="distributorWeeklyContract.dcd_from_date"
                            name="uniquename"
                            @selected="doSomethingInParentComponentFunction"
                          ></Datepicker>
                          <label
                            :class="distributorWeeklyContract.dcd_from_date ? 'active': ''"
                          >From Date</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-4 mb-4">
                      <div class="input-material">
                        <div class="add-datepicker">
                          <Datepicker :monday-first="true"
                            ref="programaticOpen"
                            v-model="distributorWeeklyContract.dcd_to_date"
                            name="uniquename"
                            @selected="doSomethingInParentComponentFunction"
                          ></Datepicker>
                          <label
                            :class="distributorWeeklyContract.dcd_to_date ? 'active': ''"
                          >To Date</label>
                        </div>
                      </div>
                    </div>
                    <div class="col-lg-6">
                      <div class="dropdown-curve-container">
                        <label
                          :class="distributorWeeklyContract.selectedDistributorShareType && distributorWeeklyContract.selectedDistributorShareType.length > 0 ? 'shift-up' : '' "
                        >{{ $t('select') }} {{ $tc('sharetype', 1) }}</label>
                        <b-dropdown
                          :text="distributorWeeklyContract.selectedDistributorShareType"
                          variant="dropdown-curve"
                          class="w-100"
                        >
                          <b-dropdown-item
                            v-for="(DistributorShareType,DistributorShareTypeIndex) in DistributorShareTypes"
                            :key="DistributorShareTypeIndex"
                            v-on:click="onSelectDistributorShareType($event, DistributorShareType, distributorWeeklyContractIndex)"
                          >{{ DistributorShareType.dst_label }}</b-dropdown-item>
                        </b-dropdown>
                      </div>
                      <span>{{ distributorWeeklyContract.dst_share_type_description }}</span>
                    </div>

                    <div class="col-lg-6">
                      <div class="row">
                        <div class="col-6 align-self-center">
                          <label class="mb-0">Share Percentage Message</label>
                        </div>
                        <div class="col-6">
                          <div class="input-material">
                            <input
                              v-model="distributorWeeklyContract.dcd_share_value"
                              type="number"
                              step="any"
                              required="required"
                            />
                            <label>{{ $t('shareValue') }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-1 border-left d-flex justify-content-center align-items-center">
                  <button
                    v-if="distributorWeeklyContractIndex === 0"
                    @click="addMoreDistributorWeeklyContracts"
                    class="btn-transparent"
                  >
                    <img src="@/assets/img/icons/plus.svg" height="30" width="30" />
                  </button>
                  <button
                    v-if="distributorWeeklyContractIndex === 0 && distributorWeeklyContracts.length !== 1"
                    @click="removeMoreDistributorWeeklyContracts(distributorWeeklyContractIndex)"
                    class="btn-transparent"
                  >
                    <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                  </button>

                  <button
                    v-if="distributorWeeklyContractIndex !== 0"
                    @click="removeMoreDistributorWeeklyContracts(distributorWeeklyContractIndex)"
                    class="btn-transparent"
                  >
                    <img src="@/assets/img/icons/minus.svg" height="30" width="30" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="col-12 text-center">
          <button
            :disabled="btenable"
            @click.prevent.stop="onFinalSubmit"
            class="btn-blue"
          >
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DistributorService from "@/services/DistributorService";
import CinemasService from "@/services/CinemasService";
import MovieService from "@/services/MovieService";

export default {
  data() {
    return {
      btenable: false,
      isRoleID: true,
      cinema_id: null,
      // Saif
      Cinemas: [],
      Movies: [],
      Distributors: [],
      Contracts: [],
      DistributorShareTypes: [],
      distributorContracts: {
        cinema_id: null,
        md_id: null,
        md_id_list: [],
        cine_id_list: [],
        d_company_name_list: [],
        contract_weekwise_name_list: [],
        distributor_id: null,
        contract_id: null,
        dc_id: null,
        dc_is_active: "Y",
        updated_by: "",
        updated_at: "",
        created_at: "",
        created_by: "",
      },
      distributorWeeklyContracts: [
        {
          dcd_from_date: null,
          dcd_to_date: null,
          dcd_from_date_timestamp: "",
          dcd_to_date_timestamp: "",
          distributor_share_type_id: null,
          selectedDistributorShareType: "",
          dcd_share_value: 0,
        },
      ],
      selecedCinema: "",
      selectedMovie: "",
      selectedDistributor: "",
      selectedContract: "",
      selectedDistributorShareType: "",

      // Saif

      checked: "y",
      selectedNewDate: "",
      selecedCinema: "",
      selectedMovie: "",
      selectedDistributor: "",
    };
  },
  beforeMount() {
    this.cinema_id = this.secureStore.get("USINFO").cinema_id;
    let obj = this.secureStore.get("USINFO").cinema_id;
    let roleid = this.secureStore.get("USINFO").role_id;
    if (true) {
      this.isRoleID = false;
    }

    const { id } = this.$route.query;
    // console.log("this.$route.query :", this.$route.query);
    if (id) {
      this.getDistributorDetails(id);
      this.getDistributorShareTypesList();
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    // Saif
    getDistributorDetails(dc_id) {
      DistributorService.GetDistributorContractById({ dc_id })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.distributorContracts = data.Records[0];
            // this.distributorWeeklyContracts =
            //   data.Records[0].DistributorWeeklyContracts;
            this.getCinemaList(this.distributorContracts.cine_id);
            this.getMoviesList(this.distributorContracts.md_id);
            this.getDistributorsList(this.distributorContracts.distributor_id);
            this.getWeekWiseContractList(this.distributorContracts.cbw_id);
            this.distributorWeeklyContracts = [];
            // data.Records[0].DistributorWeeklyContracts.map(x => {
            //   this.distributorWeeklyContracts.push({
            //     ...x,
            //     dcd_from_date: new Date(x.dcd_from_date),
            //     dcd_to_date: new Date(x.dcd_to_date),
            //     selectedDistributorShareType: x.dst_label
            //   });
            // });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getCinemaList: function (cine_id) {
      const payload = { activekey: "cine_is_active" };
      if (this.cinema_id) {
        payload.cinema_id = this.cinema_id;
        payload.conditionColName = "cine_id";
        payload.conditionId = this.cinema_id;
      }
      CinemasService.GetActiveCinemas(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Cinemas = data.Records;
            this.Cinemas.map((x) => {
              if (cine_id === x.cine_id) {
                this.selecedCinema = x.cine_name;
                this.distributorContracts.cine_name_list = x;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getMoviesList: function (md_id_list) {
      MovieService.GetActiveMoviesWithFormat()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Movies = data.Records;
            // let array = md_id_list.split(",");
            // this.distributorContracts.md_id_list = [];
            this.Movies.map((x) => {
              // let temp = array.filter(y => String(y) === String(x.md_id));
              // if (temp.length > 0) {
              if (x.md_id === md_id_list) {
                // this.distributorContracts.md_id_list.push(x);
                this.distributorContracts.md_id_list = x;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getDistributorsList: function (distributor_id) {
      DistributorService.GetActiveDistributors({ activekey: "d_is_active" })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.Distributors = data.Records;
            this.Distributors.map((x) => {
              if (String(distributor_id) === String(x.d_id)) {
                this.selectedDistributor = x.d_company_name;
                this.distributorContracts.d_company_name_list = x;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getWeekWiseContractList: function (contract_id) {
      DistributorService.GetAllWeekWiseContractList()
        .then((response) => {
          const { data } = response;
          console.log("response:", response);
          if (data.status && data.Records.length > 0) {
            this.Contracts = data.Records;
            this.Contracts.map((x) => {
              if (String(x.cbw_id) === String(contract_id)) {
                this.selectedContract = x.contract_weekwise_name;
                this.distributorContracts.contract_weekwise_name_list = x;
              }
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    getDistributorShareTypesList: function () {
      DistributorService.GetActiveDistributorShareTypes({
        activekey: "dst_is_active",
      })
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.DistributorShareTypes = data.Records;
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },

    onSelectDistributorShareType: function (
      event,
      params,
      distributorWeeklyContractIndex
    ) {
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].selectedDistributorShareType = params.dst_label;
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].distributor_share_type_id = params.dst_id;
      this.distributorWeeklyContracts[
        distributorWeeklyContractIndex
      ].dst_share_type_description = params.dst_share_type_description;
    },
    addMoreDistributorWeeklyContracts: function () {
      this.distributorWeeklyContracts.push({
        dcd_from_date: null,
        dcd_to_date: null,
        dcd_from_date_timestamp: "",
        dcd_to_date_timestamp: "",
        distributor_share_type_id: null,
        selectedDistributorShareType: "",
        dcd_share_value: 0,
        dst_share_type_description: null,
      });
    },
    removeMoreDistributorWeeklyContracts: function (index) {
      this.distributorWeeklyContracts.splice(index, 1);
    },
    onFinalSubmit: function () {
      this.btenable = true;
      let payload = {
        ...this.distributorContracts,
        // DistributorWeeklyContracts: this.distributorWeeklyContracts
      };
      DistributorService.updateDistributorContract(payload)
        .then((response) => {
          this.btenable = false;
          const { data } = response;
          if (data && data.status) {
            this.$router.push({
              path: "/distributor/distributor-contract",
            });
          } else {
            this.$toasted.show(
              data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
            );
          }
        })
        .catch(this._CatchError);
    },
    // Saif
    onSelectCinema(cinema) {
      this.selecedCinema = cinema.cine_name;
      this.distributorContracts.cinema_id = cinema.cine_id;
      this.distributorContracts.cine_name_list = cinema.cine_id;
      this.$forceUpdate();
    },
    onSelectMovie: function (params) {
      this.distributorContracts.md_id_list = params;
      this.distributorContracts.md_id = params.md_id;
      this.$forceUpdate();
    },
    onSelectDistributor(distributor) {
      this.selectedDistributor = distributor.d_company_name;
      this.distributorContracts.distributor_id = distributor.d_id;
      this.distributorContracts.d_company_name_list = distributor.d_id;
      this.$forceUpdate();
    },
    onSelecteContract(contract) {
      this.selectedContract = contract.contract_weekwise_name;
      this.distributorContracts.contract_id = contract.cbw_id;
      this.distributorContracts.contract_weekwise_name_list = contract.cbw_id;
      this.$forceUpdate();
    },
    doSomethingInParentComponentFunction: function () {},
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/DistributorContainer/DistributorContractComponents/editDistributorContract.vue